import { useMemo } from "react";

function isItemsKey(k: string): k is "items" | "data" {
  return k === "items" || k === "data";
}

export function getDocsList(raw: unknown): ReadonlyArray<{ gtin?: string | null; itemName?: string }> {
  if (raw == null || typeof raw !== "object") return [];
  const o = raw as Record<string, unknown>;
  const key = Object.keys(o).find(isItemsKey);
  const arr = key ? o[key] : undefined;
  return Array.isArray(arr) ? arr : [];
}
